module.exports = __webpack_public_path__ + "static/img/右按钮.f1dd96f4.gif";